import { gql } from "@apollo/client";

const UPDATE_USER = gql`
  mutation UserUpdate($inputs: [UpdateUserAccountInput!]!) {
    userUpdate(inputs: $inputs) {
      id
      name
      username
      role
      phone
      email
      status
    }
  }
`;

export { UPDATE_USER };
